module.exports = __webpack_public_path__ + "img/magento-services-integration_small.e67f92fc.webp";